export default __webpack_public_path__ + "static/opengraph-default-da3cdd6b2012711cbec688c73daff242.png";